import { render, staticRenderFns } from "./PersonLookup.vue?vue&type=template&id=25f7c7ac&"
import script from "./PersonLookup.vue?vue&type=script&lang=js&"
export * from "./PersonLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports